import React, { Component } from "react";
import Helmet from 'react-helmet';
import config from '../../config';
import { withPrefix } from "gatsby"

import seoTagsJSON from './../data/meta/meta.json';

export default class SeoTags extends Component {

  currLang = '';
  pathName = '';

  constructor(props) {
    super(props);

    this.pathName = typeof window !== "undefined" ? window.location.pathname : '/';
    this.currLang = this.currentLanguage;
  }

  currentLanguage = this.props.locale;

  render() {

    const title       = typeof seoTagsJSON[this.pathName] !== "undefined" ? (seoTagsJSON[this.pathName].title) : config.siteTitle;
    const description = typeof seoTagsJSON[this.pathName] !== "undefined" ? (seoTagsJSON[this.pathName].description) : seoTagsJSON[this.pathName];

    return (
      <Helmet>
        <meta charSet="utf-8" />
        <meta http-equiv="x-ua-compatible" content="ie=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"/>
        <html className="no-js" lang={this.currLang} />
        <title>{title}</title>
        <meta name="title" content={title}/>
        <meta name="description" content={description}/>
        <meta name="robots" content="INDEX, FOLLOW" />
        {
        /*
        <meta name="google-site-verification" content="txAfBhf7iPXio08-gOdThslsNVZSxMdGEPUEuycJxZk" />
        <script src={withPrefix('script.js')} type="text/javascript" />
        */
        }
      </Helmet>
    );
  }
  
}
